export const CameraIcon = ({
  size = 18,
  strokeColor = "#ffffff",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M16 12.9998L21.223 16.4818C21.2983 16.5319 21.3858 16.5606 21.4761 16.5649C21.5664 16.5693 21.6563 16.549 21.736 16.5063C21.8157 16.4636 21.8824 16.4001 21.9289 16.3225C21.9754 16.245 22 16.1562 22 16.0658V7.86978C22 7.7818 21.9768 7.69537 21.9328 7.61922C21.8887 7.54308 21.8253 7.4799 21.7491 7.43608C21.6728 7.39225 21.5863 7.36933 21.4983 7.36963C21.4103 7.36993 21.324 7.39344 21.248 7.43778L16 10.4998"
      stroke={strokeColor}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 6H4C2.89543 6 2 6.89543 2 8V16C2 17.1046 2.89543 18 4 18H14C15.1046 18 16 17.1046 16 16V8C16 6.89543 15.1046 6 14 6Z"
      stroke={strokeColor}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
